import { Dayjs } from "dayjs"

/** Mirrors the `warrants_dca_tickets_status` Postgres enum. */
export enum WarrantsDcaTicketStatus {
  SUCCESS = "success",
  FAILED = "failed",
}

/** Mirrors the `warrants_dca_type` Postgres enum. */
export enum WarrantsDcaType {
  ENGAGE = "engage",
}

/** Mirrors the `warrants_ticket_type` Postgres enum. */
export enum WarrantsTicketType {
  TRANSFER_TO_DCA = "transfer_to_dca",
  RECALL = "recall",
}

export interface IWarrantsDcaTicket {
  id: number
  accountNumber: string
  /** `warrants_dca_type` PG enum, e.g. 'no_access'. */
  dcaType: string
  /** `warrants_dca_tickets_status` PG enum, e.g. 'open'. */
  status: string
  /** `warrants_ticket_type` PG enum. */
  type: string
  ticketDefinition: string | null
  ticketId: string | null
  ticketStep: string | null
  createdAt: Dayjs
  deletedAt: Dayjs | null

  /** `deleted_at` is set. */
  readonly isDeleted: boolean
  /** The status enum value rendered for display, e.g. 'Open'. */
  readonly statusDisplay: string
  /** The dca_type enum value rendered for display. */
  readonly dcaTypeDisplay: string
  /** The type enum value rendered for display. */
  readonly typeDisplay: string
}
